module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.c71557c3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-DemiBold.eot?#iefix
// module id = 83
// module chunks = 0